import { CardPhotoType, parsePotentialPropertyMedia } from '@/containers/PriorityDetail/utils'
import { Listings_Detail, Photos, PotentialPropertyByFilterQuery } from '@/types/cate-graphql-generated-types'
import { CardDataListing, CardDataPriority, PropertyType } from '@/types/property-card'

import fragmentCounter from '../balcony-counter'
import getTranslatedTitle from '../get-translated-title'

export const mapListingPhotosIntoCardPhotos = (propertyPhotos: Photos[]): CardPhotoType[] =>
  propertyPhotos.map((photo) => ({ isPrimary: photo.isPrimary, url: photo.url }))

export const mapPrioritiesIntoCardDataPriority = (
  priorities: PotentialPropertyByFilterQuery['potential_property']
): CardDataPriority[] => {
  return priorities.map((priority) => ({
    bathrooms: priority.bathrooms,
    buildingFloors: priority.buildingFloors,
    city: priority.city,
    commercialArea: priority.commercialArea,
    energyRating: priority.energyRatingClass,
    entranceFloor: priority.entranceFloor,
    estimatedListingPrice: {
      cents: priority.estimatedListingPrice?.cents ?? 0,
      currency: priority.estimatedListingPrice?.currency ?? 'eur',
    },
    floorPosition: [],
    //TODO: check the data coming from terraceAreas and gardenAreas
    hasOutdoorSpace: false,
    id: priority.transactionId,
    insertedAt: priority.insertedAt,
    photos: parsePotentialPropertyMedia(priority.potentialPropertyMedia).photoGallery,
    price: { cents: priority.askedPrice?.cents ?? 0, currency: priority.askedPrice?.currency ?? 'eur' },
    rooms: priority.rooms,
    slug: priority.slug,
    stateOfMaintenance: priority.stateOfMaintenance,
    status: priority.status,
    title: priority.title,
    type: PropertyType.Priority,
    zone: priority.zone,
  }))
}

export const mapListingsIntoCardDataListing = (listings: Listings_Detail[], locale: Locale): CardDataListing[] => {
  return listings.map((listing) => {
    return {
      bathrooms: listing.characteristics.bathrooms,
      buildingFloors: listing.detail.buildingFloors,
      city: listing.detail.city,
      commercialArea: listing.detail.commercialArea,
      energyRating: listing.additionalInfo.energyRating,
      entireBuilding: listing.detail.entireBuilding,
      entranceFloor: listing.detail.entranceFloor,
      floorPosition: listing.detail.floorPosition,
      hasOutdoorSpace: (fragmentCounter.get(listing.characteristics.terraces) > 0 || listing.services.garden) ?? false,
      id: listing.id,
      inventory: listing.detail.inventory,
      isPrivateNegotiation: listing.detail.privateNegotiation,
      ownedByCasavo: listing.contactInfo.ownedByCasavo,
      photos: mapListingPhotosIntoCardPhotos(listing.photos),
      price: {
        cents: listing.detail.sellingPrices?.cents ?? 0,
        currency: listing.detail.sellingPrices?.currency ?? 'eur',
      },
      rooms: listing.characteristics.rooms,
      stateOfMaintenance: listing.characteristics.stateOfMaintenance,
      title: getTranslatedTitle(listing.detail.titles, locale),
      type: PropertyType.Listing,
      zone: listing.detail.zone,
    }
  })
}
